import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function LegalPage({ namespace, testId }) {
  const { t } = useI18n();
  const sections = t(`${namespace}.sections`);

  return (
    <main style={{ backgroundColor: "#FAF8F5", color: "#1C1917" }} data-testid={testId}>
      <div className="mx-auto max-w-3xl px-6 lg:px-10 py-16 lg:py-24">
        <div className="font-mono text-xs uppercase tracking-[0.25em]" style={{ color: "#8A6E1E" }}>
          {t(`${namespace}.updated`)}
        </div>
        <h1 className="mt-6 font-serif text-4xl lg:text-5xl leading-tight tracking-tight" style={{ color: "#1C241C" }}>
          {t(`${namespace}.title`)}
        </h1>
        <p className="mt-8 font-sans text-base leading-relaxed" style={{ color: "#3F3B36" }}>
          {t(`${namespace}.intro`)}
        </p>
        <div className="mt-12 space-y-10">
          {Array.isArray(sections) &&
            sections.map((sec, idx) => (
              <section key={idx}>
                <h2 className="font-serif text-2xl" style={{ color: "#1C241C" }}>
                  {sec.heading}
                </h2>
                <p className="mt-4 font-sans text-base leading-relaxed" style={{ color: "#3F3B36" }}>
                  {sec.body}
                </p>
              </section>
            ))}
        </div>
      </div>
    </main>
  );
}
